import gql from 'graphql-tag'

export default gql`
query listClientMessage($params: ListQueryArgs, $filter: ClientMessageFilter){
	cashAssist {
		listClientMessage(params: $params, filter: $filter) {
			items {
				id
				createdAt
				subject
				sender
				isForShop
				body(type: plain)
			}
			total
			hasNextPage
	  	}
	}
}`
